<template>
  <div class="inputBox">
    <ValidationProvider
      vid="email"
      rules="required|email"
      name="email"
      v-slot="{ failed, errors }"
    >
      <div
        class="inputWrapper"
        :class="[isFocus ? 'focus' : '', failed ? 'error' : '']"
      >
        <input
          ref="r"
          type="email"
          label="email"
          aria-label="email"
          :value="value"
          :disabled="isDisabled"
          :class="failed ? 'error' : ''"
          @focus="onFocus"
          @blur="onBlur"
          @input="updateValue"
          @change="updateValue"
        />
        <label
          @click="inputOnFous"
          :class="[
            isFocus == true ? 'focus' : '',
            value != '' ? 'hasData' : '',
            failed ? 'error' : '',
          ]"
          v-html="$t('authorization.emailLabel')"
          class="title"
        />
        <span class="error" v-html="errors[0]" />
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider, localize, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import ja from "vee-validate/dist/locale/ja";
extend("required", required);
extend("email", email);
localize("ja", ja);
export default {
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: false,
    };
  },
  methods: {
    onFocus() {
      if (this.isDisabled === true) {
        return;
      }
      this.isFocus = true;
    },
    onBlur() {
      if (this.isDisabled === true) {
        return;
      }
      this.isFocus = false;
    },
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
    inputOnFous() {
      if (this.isDisabled === true) {
        return;
      }
      this.$nextTick(() => this.$refs.r.focus());
    },
  },
};
</script>

<style lang="sass" scoped>
.inputBox
  position: relative
  .inputWrapper
    +size (calc(100% - 4px), 48px, 5px)
    position: relative
    box-shadow: 0 0 0 1px $gs2
    margin: 2px
    transition: 0.3s
    box-sizing: border-box
    &.focus
      box-shadow: 0 0 0 2px $color1
    &.error
      box-shadow: 0 0 0 2px $color3
    input
      +size (100%, 100%, 5px)
      +fs(l)
      background-color: transparent
      padding: 0 16px
      box-sizing: border-box
      &[disabled]
        background-color: rgba($gs4, 0.2)
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active
        -webkit-box-shadow: 0 0 0 30px $gs1 inset !important
    .title
      +fs(m)
      +ffw(normal)
      +abpos(12px, initial, 11px, initial)
      background-color: $gs1
      color: rgba($gs2, 0.5)
      padding: 5px 5px
      transition: 0.3s
      cursor: text
      @media all and (-ms-high-contrast:none)
        +abpos(12px, initial, 15px, initial)
      &.hasData
        +fs(xs)
        +ffw(bold)
        +abpos(8px, initial, -10px, initial)
        color: $gs2
        &.error
          color: $color3
      &.focus
        +fs(xs)
        +ffw(bold)
        +abpos(8px, initial, -10px, initial)
        color: $color1
        &.error
          color: $color3
  span.error
    +fs(xs)
    +lh(14)
    padding: 3px 0
    color: $color3
    display: block
    transition: 0.3s
    margin-top: 4px
::placeholder
  color: rgba($gs2, 0.5)

// All responsive page
+mq
  .inputWrapper
    input
      +fs(l)
</style>
